/**
 * For the purchase reports (used with inventoryReportMixin, periodReportMixin and salesReportMixin for the charts):
 * the Supplier filter and a print table built from column descriptions.
 * The component's `filters` hold `supplier` besides its other filters.
 */
import { escapeHtml } from '../inventory/inventoryReportMixin';

export const PURCHASE_COLOR = '#2D6CDF';
export const STATUS_TONES = { paid: 'success', partial: 'warning', unpaid: 'danger' };

export default {
  computed: {
    supplierOptions() {
      return (this.options.suppliers || []).map((s) => {
        const parts = [s.name];
        if (s.phone) parts.push(s.phone);
        const bal = Number(s.balance) || 0;
        if (Math.abs(bal) > 0.005) parts.push(`Due ${this.formatMoney(Math.abs(bal))}`);
        return { id: s.id, text: parts.join(' · ') };
      });
    },
  },

  watch: {
    'filters.supplier'() { this.onFilterChange(); },
  },

  methods: {
    supplierParams() {
      return this.filters.supplier ? { supplier: this.filters.supplier } : {};
    },

    supplierText() {
      return `Supplier: ${this.optionName(this.options.suppliers || [], this.filters.supplier, 'All')}`;
    },

    /**
     * Prints `rows` as a table. columns: [{ label, value(row) -> text, num? }]; `totals` maps column labels to the
     * totals row's text (the first column says "Total" otherwise). Texts are escaped here.
     */
    printColumns(title, metaParts, cards, columns, rows, totals = null) {
      const cell = (column, text) => `<td${column.num ? ' class="num"' : ''}>${escapeHtml(text ?? '')}</td>`;
      const head = columns.map((c) => `<th${c.num ? ' class="num"' : ''}>${escapeHtml(c.label)}</th>`).join('');
      const body = rows.map((row) => `<tr>${columns.map((c) => cell(c, c.value(row))).join('')}</tr>`).join('');
      const foot = totals
        ? `<tfoot><tr>${columns.map((c, i) => cell(c, totals[c.label] ?? (i === 0 ? 'Total' : ''))).join('')}</tr></tfoot>`
        : '';
      this.openPrint(
        title,
        [metaParts.filter(Boolean).join(' · '), `Printed ${new Date().toLocaleString()}`],
        cards.map(([label, value]) => [label, escapeHtml(value)]),
        `<table><thead><tr>${head}</tr></thead><tbody>${body}</tbody>${foot}</table>`,
      );
    },
  },
};
